<template>
<div class="search-wrapper" ref="searchWrapper">
  <span class="icon-clear-wrapper" @click="clearSearch" v-if="this.query !== ''">
    <BaseIcon class="icon-clear" name="times-circle" />
  </span>
  <baseInput inputType="text" placeholder="Search" v-model="query" />
  <BaseCheckboxTags class="checkbox-tags" name="health_options" :items="healthPrefs" />

  <div class="btn-wrapper">
    <BaseButton type="button" class="btn-large btn-step" @click="save">
      Save
    </BaseButton>
  </div>
</div>
</template>

<script>
import { breakpointsMixin } from 'breakpointsMixin';
import { userComputed, userMethods, kitchenDrawerMethods } from '@state/helpers';

export default {
  mixins: [breakpointsMixin],
  components: {},
  props: {
    onTabletUp: {
      type: Boolean,
    },
  },
  data() {
    return {
      isValid: false,
      query: '',
      showTagsCount: 16,
    };
  },
  computed: {
    ...userComputed,
    healthPrefs() {
      if (this.preferences) {
        const healthPrefs = this.preferences.filter((pref) => pref.preferenceCategoryId === 3);

        if (this.query) {
          return healthPrefs.filter((pref) => pref.name.toLocaleLowerCase().includes(this.query.toLocaleLowerCase()));
        } else {
          return healthPrefs.slice(0, this.showTagsCount);
        }
      } else {
        return [];
      }
    },
  },
  mounted() {
    this.calcVisibleHealthTags();
  },
  methods: {
    ...kitchenDrawerMethods,
    ...userMethods,
    calcVisibleHealthTags() {
      if (this.$refs.searchWrapper) {
        const stepsHeight = this.$refs.searchWrapper.clientHeight;

        if (stepsHeight <= 568) {
          this.showTagsCount = 7;
        } else if (stepsHeight <= 667) {
          this.showTagsCount = 12;
        } else if (stepsHeight <= 667) {
          this.showTagsCount = 14;
        }
      }
    },
    save() {
      this.updatePreferences({ preferences: this.preferences });
      this.navigateHigher();
    },
    clearSearch() {
      if (this.query !== '') {
        this.query = '';
      }
    },
    onValidate(evt) {
      this.isValid = evt;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.search-wrapper {
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 0 2rem 0.8rem;
  text-align: center;

  .icon-clear-wrapper {
    position: absolute;
    right: 4rem;
    top: 9rem;

    .icon-clear {
      font-size: 1.3rem;

      &:hover {
        cursor: pointer;
      }
    }
  }

  input {
    margin: 2rem 0;
    text-align: center;

    &::-webkit-input-placeholder {
      line-height: 1.4;
    }

    &::-moz-placeholder {
      line-height: 1.4;
    }

    &:-ms-input-placeholder {
      line-height: 1.4;
    }

    &:-moz-placeholder {
      line-height: 1.4;
    }
  }
}

.checkbox-tags {
  width: 100%;
}
</style>
